import { useId as reactUseId } from 'react';
export const useId = (idOverride) => {
    const reactId = reactUseId();
    return idOverride ?? reactId;
};
